import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React from 'react'

import {BoxIcon, Header} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {orderPath} from 'src/shared/utils'

import {PointAddress} from '../../PointAddress/PointAddress'
import {PointContact} from '../../PointContact/PointContact'

export function SourcePointExpress(): React.ReactElement {
  return (
    <Paper radius="L">
      <Grid data-e2e="source-point" size="m" container>
        <Grid xs={12} item>
          <Header lead={<BoxIcon />}>{i18n('cargo.create.form.from', 'Откуда')}</Header>
        </Grid>
        <Grid xs={12} item>
          <PointAddress data-testid="source_point_address" name={orderPath('sourcePoint.address')} pointType="a" />
        </Grid>
        <Grid xs={12} item>
          <PointContact
            name={orderPath('sourcePoint.contact')}
            title={i18n('cargo.create.form.source', 'Отправитель')}
            isSmsConfirmationEnabled
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
